import drivers from '../screens/Drivers/reducer'
import incidents from '../screens/Incidents/reducer'
import fleet from '../screens/Fleet/reducer'
import fleetDetails from '../screens/FleetDetails/reducer'
import invites from '../screens/Invites/reducer'
import loads from '../screens/Loads/reducer'
import loadsDetails from '../screens/LoadsDetails/reducer'
import newFleet from '../screens/NewFleet/reducer'
import notifications from '../screens/Notifications/reducer'
import settings from '../screens/Settings/reducer'
import shippers from '../reducers/shippers'
import historyLoads from '../screens/DeliveryLoadsHistory/reducer'
import users from '../screens/UserRegistration/reducer'
import loadTable from '../screens/LoadTable/reducer'
import notices from '../components/DailyAlertModal/reducer'
import pendings from '../screens/Pendings/reducer'
import newLoads from '../screens/NewLoads/reducer'
import { bidsReducer } from '../screens/Bids/reducer'
import { bidDetails } from '../screens/BidDetails/reducer'
import { tollVouchers } from '../screens/TollVouchers/reducer'

import { userContact } from './userContact'
import errors from './errors'
import user from './user'
import system from './system'
import uiDrawers from './uiDrawers'
import centrifugeLoads from './centrifugeLoads'
import mapbox from './mapbox'
import googleMaps from './googleMaps'
import centrifuge from './centrifuge'
import application from './application'
import { communication } from './communication'

export default {
  application,
  centrifuge,
  drivers,
  incidents,
  historyLoads,
  fleet,
  fleetDetails,
  googleMaps,
  invites,
  centrifugeLoads,
  loads,
  loadsDetails,
  mapbox,
  newFleet,
  notifications,
  settings,
  system,
  uiDrawers,
  shippers,
  user,
  users,
  loadTable,
  notices,
  errors,
  pendings,
  userContact,
  newLoads,
  bidsReducer,
  bidDetails,
  tollVouchers,
  communication,
}
